<script setup lang="ts">
import { useCustomizerStore } from '@/stores/customizer';
import { ref } from 'vue';
import { CheckIcon } from 'vue-tabler-icons';

import { Icon } from '@iconify/vue';

const customizer = useCustomizerStore();

// themes color options
const themeColors = ref([
    {
        name: 'BLUE_THEME',
        bg: 'themeBlue'
    },
    {
        name: 'AQUA_THEME',
        bg: 'themeAqua'
    },
    {
        name: 'PURPLE_THEME',
        bg: 'themePurple'
    },
    {
        name: 'GREEN_THEME',
        bg: 'themeGreen'
    },
    {
        name: 'CYAN_THEME',
        bg: 'themeCyan'
    },
    {
        name: 'ORANGE_THEME',
        bg: 'themeOrange'
    }
]);

// Dark Theme Colors
const DarkthemeColors = ref([
    { name: 'DARK_BLUE_THEME', bg: 'themeDarkBlue' },
    { name: 'DARK_AQUA_THEME', bg: 'themeDarkAqua' },
    { name: 'DARK_PURPLE_THEME', bg: 'themeDarkPurple' },
    { name: 'DARK_GREEN_THEME', bg: 'themeDarkGreen' },
    { name: 'DARK_CYAN_THEME', bg: 'themeDarkCyan' },
    { name: 'DARK_ORANGE_THEME', bg: 'themeDarkOrange' }
]);
</script>

<!------------------------------------->
<!-- Customizer -->
<!------------------------------------->
<template>
    <div class="pa-6">
        <h5 class="text-h5">Customização do Sistema</h5>
    </div>
    <v-divider></v-divider>
    <perfect-scrollbar style="height: calc(100vh - 90px); overflow-x: hidden">
        <div class="pa-6">
            <h6 class="text-h6 mb-2">Layout da Sidebar</h6>
            <v-btn-toggle
                v-model="customizer.setHorizontalLayout"
                color="primary"
                class="my-2 btn-group-custom gap-3"
                rounded="0"
                group
                @update:model-value="customizer.SET_LAYOUT"
            >
                <v-btn :value="false" variant="text" elevation="10" class="rounded-xl">
                    <Icon icon="solar:slider-vertical-minimalistic-linear" height="22" width="22" size="22" class="mr-2 icon" />
                    Vertical
                </v-btn>
                <!-- Botão Horizontal - DESABILITADO TEMPORARIAMENTE
                    <v-btn :value="true" variant="text" elevation="10" class="rounded-xl">
                        <Icon icon="solar:slider-minimalistic-horizontal-outline" height="22" width="22" size="22" class="mr-2 icon" /> Horizontal
                    </v-btn>
                    -->
            </v-btn-toggle>

            <h6 class="text-h6 mt-8 mb-5">Cores do Tema</h6>

            <v-item-group mandatory v-model="customizer.actTheme" class="ml-n2 v-row" @update:model-value="customizer.SET_THEME">
                <v-col cols="4" v-for="theme in themeColors" :key="theme.name" class="pa-2">
                    <v-item v-slot="{ isSelected, toggle }" :value="theme.name">
                        <v-sheet
                            rounded="xl"
                            class="border cursor-pointer d-block text-center px-5 py-4 hover-btns"
                            elevation="10"
                            @click="toggle"
                        >
                            <v-avatar :class="theme.bg" size="25">
                                <CheckIcon color="white" size="18" v-if="isSelected" />
                            </v-avatar>
                        </v-sheet>
                    </v-item>
                </v-col>
            </v-item-group>
            <h6 class="text-h6 mt-11 mb-5">Cores do Tema Escuro</h6>

            <v-item-group mandatory v-model="customizer.actTheme" class="ml-n2 v-row" @update:model-value="customizer.SET_THEME">
                <v-col cols="4" v-for="theme in DarkthemeColors" :key="theme.name" class="pa-2">
                    <v-item v-slot="{ isSelected, toggle }" :value="theme.name">
                        <v-sheet
                            rounded="xl"
                            class="border cursor-pointer d-block text-center px-5 py-4 hover-btns"
                            elevation="10"
                            @click="toggle"
                        >
                            <v-avatar :class="theme.bg" size="25">
                                <CheckIcon color="white" size="18" v-if="isSelected" />
                            </v-avatar>
                        </v-sheet>
                    </v-item>
                </v-col>
            </v-item-group>
            <h6 class="text-h6 mt-11 mb-2">Opção de Container</h6>
            <v-btn-toggle
                v-model="customizer.boxed"
                color="primary"
                class="my-2 btn-group-custom gap-3"
                rounded="0"
                group
                @update:model-value="customizer.SET_BOXED"
            >
                <v-btn :value="true" variant="text" elevation="10" class="rounded-xl">
                    <Icon icon="solar:cardholder-linear" height="22" width="22" size="22" class="mr-2 icon" />
                    Compacto
                </v-btn>
                <v-btn :value="false" variant="text" elevation="10" class="rounded-xl">
                    <Icon icon="solar:scanner-linear" height="22" width="22" size="22" class="mr-2 icon" />
                    Completo
                </v-btn>
            </v-btn-toggle>
            <!---Horizontal demo hide this option --->
            <v-sheet v-if="customizer.setHorizontalLayout != true">
                <h6 class="text-h6 mt-11 mb-2">Tipo de Sidebar</h6>
                <v-btn-toggle
                    v-model="customizer.mini_sidebar"
                    color="primary"
                    class="my-2 btn-group-custom gap-3"
                    rounded="0"
                    group
                    @update:model-value="customizer.SET_MINI_SIDEBAR"
                >
                    <v-btn :value="false" variant="text" elevation="10" class="rounded-xl">
                        <Icon icon="solar:sidebar-minimalistic-outline" height="22" width="22" size="22" class="mr-2 icon" />
                        Aberto
                    </v-btn>
                    <v-btn :value="true" variant="text" elevation="10" class="rounded-xl">
                        <Icon icon="solar:siderbar-outline" height="22" width="22" size="22" class="mr-2 icon" />
                        Fechado
                    </v-btn>
                </v-btn-toggle>
            </v-sheet>
        </div>
    </perfect-scrollbar>
</template>

<style lang="scss">
.customizer-container {
    overflow-x: hidden !important;
    max-width: 100% !important;
}

.ps__rail-x {
    display: none !important;
}

.ps__rail-y {
    display: block !important;
}
</style>
